// extracted by mini-css-extract-plugin
module.exports = {"heading":"DateRangeRadioGroup_heading__RCWLL","radioGroupContainer":"DateRangeRadioGroup_radioGroupContainer__8SIlR"};